import { useState } from "react";
import { Instalacion } from "../../../../../types/Instalacion";
import Table, { ColumnDefinitionType } from "../../../../../components/Table";
import { Link } from "react-router-dom";
import { Loading } from "../../../../../components/Loading";
import MyModal from "../../../../../components/Modal";
import Confirm from "../../../../../components/Confirm";
import ModalInstalacion from "./ModalInstalacion";


type InstalacionesProps = {
    instalaciones: Instalacion[],
    setInstalaciones: (value: Instalacion[]) => void,
    edit: boolean,
    view: boolean,
    loading?: boolean,
}

type FormErrors = {
    nombre?: string;
};

const instalacionInicial: Instalacion = {
    id: 0,
    nombre: '',
    domicilio: '',
    telefono: '',
    localidad: '',
    idEmpresaGestora: 0,
}

// Genera un id temporal negativo y único para identificar en el estado local
// las instalaciones que aún no fueron persistidas (el backend asigna un id
// real y positivo recién cuando se guarda la Empresa Gestora completa)
const proximoIdTemporal = (instalaciones: Instalacion[]) => {
    const minimo = instalaciones.reduce((min, inst) => Math.min(min, inst.id || 0), 0);
    return minimo - 1;
}

const SeccionInstalaciones = ({ edit, view, instalaciones, setInstalaciones, loading = false }: InstalacionesProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleModal = () => setIsOpen(!isOpen);
    const [showModal, setShowModal] = useState<boolean>(false);
    const toggle = () => setShowModal(!showModal);
    const [isEditInstalacion, setIsEditInstalacion] = useState(false);
    const [instalacionForm, setInstalacionForm] = useState<Instalacion>(instalacionInicial);
    const [data, setData] = useState<Instalacion>(instalacionInicial);
    const [formErrors, setFormErrors] = useState<FormErrors>({ nombre: '' });

    const eliminar = () => {
        let instalacionesRestantes: Instalacion[] = instalaciones.filter(inst => inst.id !== data.id)
        setInstalaciones(instalacionesRestantes);
        toggle();
    }

    const columns: ColumnDefinitionType<Instalacion, keyof Instalacion>[] = []
    columns.push({
        key: 'nombre',
        header: 'Nombre',
    });
    columns.push({
        key: 'domicilio',
        header: 'Domicilio',
    });
    columns.push({
        key: 'telefono',
        header: 'Teléfono',
    });
    columns.push({
        key: 'localidad',
        header: 'Localidad',
    });
    if (!view) {
        columns.push({
            key: 'id',
            header: 'Acciones',
            cell: (data: Instalacion) =>
                <>
                    <Link to="#" title="Editar"
                        onClick={(e) => {
                            e.stopPropagation();
                            setInstalacionForm(data);
                            setIsEditInstalacion(true);
                            setFormErrors({ nombre: '' });
                            toggleModal();
                        }}
                    >
                        <i className="fa fa-pencil text-custom" aria-hidden="true"></i>
                    </Link>

                    <Link to="#" title="eliminar"
                        onClick={(e) => {
                            e.stopPropagation();
                            setData(data);
                            setShowModal(true)

                        }}
                    >
                        <i className="fa fa-trash-o mr-2 text-danger" aria-hidden="true"></i>
                    </Link>

                </>
        });
    }

    const validateForm = (instalacion: Instalacion) => {
        const errors: FormErrors = {};
        if (!instalacion.nombre) {
            errors.nombre = 'El campo Nombre es obligatorio'
        }
        return errors;
    }

    const handleConfirm = () => {
        const errors = validateForm(instalacionForm);
        if (Object.keys(errors).length === 0) {
            if (isEditInstalacion) {
                const instalacionesActualizadas = instalaciones.map(inst => inst.id === instalacionForm.id ? instalacionForm : inst);
                setInstalaciones(instalacionesActualizadas);
            } else {
                const nuevaInstalacion: Instalacion = { ...instalacionForm, id: proximoIdTemporal(instalaciones) };
                setInstalaciones([...instalaciones, nuevaInstalacion]);
            }
            toggleModal();
        }
        setFormErrors(errors);
    }

    return (
        <>
            <Confirm isOpen={showModal} toggle={toggle} title='Eliminar' yesFn={eliminar}>
                <div className="form-horizontal">
                    <div className="row">
                        {<p>Está seguro que desea eliminar la instalación {data.nombre}?</p>}
                    </div>
                </div>
            </Confirm>
            <div className="card mt-4">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h4 className="m-t-0 header-title">
                                        <i className="fa fa-list-ul" aria-hidden="true" style={{ marginRight: "5px" }}></i>

                                        Instalaciones
                                        {!view &&
                                            <Link to="#" title="Agregar" className="btn-custom btn-rounded waves-effect waves-light pull-right btn-sm" style={{ marginTop: '-8px' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setInstalacionForm(instalacionInicial);
                                                    setIsEditInstalacion(false);
                                                    setFormErrors({ nombre: '' });
                                                    toggleModal();
                                                }}>
                                                <i className="fa fa-plus margin-right-10"></i> Agregar
                                            </Link>}

                                    </h4>

                                </div>

                                <div className="table-responsive">
                                    <br />
                                    <MyModal isOpen={isOpen} toggle={toggleModal} title={isEditInstalacion ? 'Editar Instalación' : 'Agregar Instalación'} size="md"
                                        secondButton={true} secondButtonTitle={'Aceptar'} titleCancelar={'Cancelar'} secondButtonFn={handleConfirm}
                                    >
                                        <ModalInstalacion instalacionForm={instalacionForm} setInstalacionForm={setInstalacionForm} formErrors={formErrors} />
                                    </MyModal>
                                    {loading ? <Loading /> : <Table data={instalaciones || []} columns={columns}></Table>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SeccionInstalaciones;
